import { Icon } from "../icons/icons";
import { Tooltip, type TooltipProps } from "./tooltip";

export function HintTooltip(props: TooltipProps) {
	/** Render */
	return (
		<Tooltip
			openDelay={0}
			{...props}
		>
			<Icon
				name="HelpCircle"
				className="cursor-pointer"
			/>
		</Tooltip>
	);
}
